import React, { useContext, useEffect } from 'react'
import Link from 'next/link'
import {
	Button,
	Image
} from 'react-bootstrap'
import UserContext from '../UserContext'
import { createClient } from 'graphqurl'
import moment from 'moment'
import { useTranslation } from 'react-i18next'

export default function BroadcastSuccess ({ isLogin, action, counter }): JSX.Element {
	const { t } = useTranslation()
	const { user } = useContext(UserContext)

	const handleUpdate = async (): Promise<void> => {
		const token = window.localStorage.getItem('token')
		const inputs = {
			broadcastStartDate: action === 'broadcast' ? moment().format() : null,
			broadcastEndDate: action === 'broadcast' ? moment().add(1, 'years').format() : null
		}
    
		try {
			const client = createClient({
				endpoint: process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT as string,
				headers: {
					authorization: token ? `Bearer ${token}` : ''
				}
			})
			const hasuraMutation = client.query({
				query:`
        mutation ($id: Int!, $changes: Applicant_set_input) {
          update_Applicant_by_pk(pk_columns: {id: $id} _set: $changes) {
            id
            name
            email
            avatar
            contact
          }
        }
        `,
				variables: {
					id: user.id,
					changes: inputs,
				}
			})
			const hasuraRes = await hasuraMutation
			window.localStorage.setItem('profile', JSON.stringify(hasuraRes.data.update_Applicant_by_pk))
		} catch (err) {
			console.error(err)
		}
	}

	useEffect(() => {
		handleUpdate()
	})

	return (
		<div className='text-center bg-white py-5'>
			<Image src='/img/job_apply_success.png' alt=''/>
			{action === 'broadcast' ? (
				<p className='mt-3 mb-5'><strong>{t('broadcast.success')}</strong></p>
			) : (
				<p className='mt-3 mb-5'><strong>{t('broadcast.stop')}</strong></p>
			)}
			{isLogin ? (
				<>
					<p style={{ color: '#3A4B5F', fontSize: 'small' }}>{t('broadcast.redirect')}{counter}{t('broadcast.seconds')}</p>
					<Link href='/jobs' passHref>
						<Button className='text-white'>{t('broadcast.findjobs')}</Button>
					</Link>
				</>
			) : (
				<Button
					className='text-white'
					onClick={() => window.location.reload()}
					style={{ borderRadius: '10px' }}
				>
					{t('broadcast.back_to_profile')}
				</Button>
			)}
		</div>
	)
}
